import { Skeleton } from "antd";
import API from "API";
import Management from "components/general/Management";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import QuizzTest from "./QuizzTest";

const testTypeOptions = [
    {value: 0, label: "Lấy điểm lớn nhất"},
    {value: 1, label: "Lấy điểm trung bình"},
    {value: 2, label: "Chuyên cần"},
]

function UniversityTest() {
    const { id } = useParams();
    const [test, setTest] = useState(null);
    const [lessons, setLessons] = useState(null);
    const [loadingTest, setLoadingTest] = useState(true);

    useEffect(() => {
        if (!test) return;
        document.title = `${test.course_name} - ${test.title}`
        // eslint-disable-next-line
    },[test?.id])

    const loadTest = useCallback(async () => {
        try {
            setLoadingTest(true);
            const res = await API.get(`/tests/${id}`);
            for (const r of res.data.releases) {
                r.start_time = dayjs(r.start_time);
                r.end_time = dayjs(r.end_time);
            }
            setTest(res.data);
        } catch (err) {
            console.error("Lỗi khi tải bài kiểm tra", err);
        } finally {
            setLoadingTest(false);
        }
    }, [id]);

    useEffect(() => {
        if (id) loadTest();
    }, [id, loadTest]);

    useEffect(() => {
        if (test?.course) loadLessons(test?.course);
        // eslint-disable-next-line
    }, [test?.id]);

    const loadLessons = async (course) => {
        try {
            setLoadingTest(true);
            const res = await API.get(`/courses/${course}`);
            setLessons(
                res.data?.lessons?.map(({ id, name }) => ({
                    value: id,
                    label: name,
                }))
            );
        } catch (err) {
            console.error("Lỗi khi tải bài kiểm tra", err);
        } finally {
            setLoadingTest(false);
        }
    };

    const layout = [
        [
            {
                label: "Thời gian bắt đầu",
                name: "start_time",
                type: "dateTime",
                rules: [{ required: true }],
            },
            {
                label: "Thời gian kết thúc",
                name: "end_time",
                type: "dateTime",
                rules: [
                    { required: true },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            const start = getFieldValue("start_time");
                            if (!value || !start || value.isAfter(start)) {
                                return Promise.resolve();
                            }
                            return Promise.reject(
                                new Error("Ngày kết thúc phải sau ngày bắt đầu")
                            );
                        },
                    }),
                ],
            },
        ],
        [
            {
                label: "Loại bài",
                name: "type",
                type: "select",
                options: testTypeOptions,
                rules: [{ required: true }],
            },
            {
                label: "Số lần làm bài",
                name: "limit",
                type: "inputNumber",
                rules: [{ required: true }],
            },
        ],
    ];

    const fetchRelease = async ({ searchTerm }) => {
        return {
            data: test.releases || [],
        };
    };
    const columns = [
        {
            title: "Thời gian bắt đầu",
            dataIndex: "start_time",
            key: "start_time",
            render: (value) => value.format("DD/MM/YYYY HH:mm:ss"),
        },
        {
            title: "Thời gian kết thúc",
            dataIndex: "end_time",
            key: "end_time",
            render: (value) => value.format("DD/MM/YYYY HH:mm:ss"),
        },
        {
            title: "Loại bài",
            dataIndex: "type",
            key: "type",
            render: (value) => testTypeOptions.find(item => item.value === value).label,
        },
        { title: "Giới hạn", dataIndex: "limit", key: "limit" },
    ];

    return loadingTest ? (
        <Skeleton active />
    ) : (
        <>
            <h4>Thiết lập bài kiểm tra</h4>
            <span
                style={{ fontWeight: 400 }}
            >{`${test?.course_name} - ${test?.title}`}</span>
            <h6 style={{ marginTop: "15px" }}>Thời gian kiểm tra</h6>
            <Management
                layout={layout}
                columns={columns}
                apiPath={`/test-releases/`}
                itemName="thời gian kiểm tra"
                listMode="table"
                fetchData={fetchRelease}
                useFrontendPagination={false}
                additionalPostData={{ test: id }}
                onReload={loadTest}
                disableSearch={true}
                dateFields={[
                    {field: "start_time", type: "dateTime"}, 
                    {field: "end_time", type: "dateTime"},
                ]}
            />

            <h6 style={{ marginTop: "15px" }}>Cài đặt câu hỏi</h6>

            <QuizzTest test={test} setTest={setTest} lessons={lessons} />
        </>
    );
}

export { testTypeOptions };
export default UniversityTest;
